import  { Component } from "react";
import { Card, Row, Col, Tab, Tabs, Spinner, Button, Alert } from "react-bootstrap";
import api from "../../services/api";
import { withRouter } from '../../common/with-router';
import { getCurrentUser, formataDataHoraExibicao } from '../../common/utils';
import { FaDownload, FaExclamationTriangle } from "react-icons/fa";

class TermosMedico extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            loadingPdf: {
                termo: true,
                regulamento: true,
                privacidade: true,
                cookies: true
            },
            titulo_pagina: "Termos e Políticas",
            programa_dados: {},
            prestador_dados: {},
            loadingDados: true,
            erro: ""
        };
    }

    componentDidMount() {
        const dados_user = getCurrentUser();
        let id = '';

        if (dados_user['tipo_usuario'] === 'prestador') {
            id = dados_user['prestador_id'];
        } else {
            this.props.router.navigate("/home");
            return;
        }

        api.get(`/pessoas/prestadores/${id}`)
            .then(response => {
                this.setState({
                    prestador_dados: response.data,
                });
            })
            .catch(error => {
                console.error('Erro ao consultar dados do prestador:', error);
            });

        this.carregaDadosPrograma();
    }

    carregaDadosPrograma = async () => {
        let dados_usuario = getCurrentUser();
        
        let programa_id = dados_usuario['ambiente_programa_id'];

        if (!programa_id && this.props.router?.params?.id) {
            programa_id = this.props.router.params.id;
        }

        this.setState({ loadingDados: true });

        if (!programa_id && dados_usuario['tipo_usuario'] === 'prestador') {
            try {
                const prestador_id = dados_usuario['prestador_id'];
                // Busca os vinculos do prestador para descobrir o programa
                const responseVinculos = await api.get(`/programas/prestadores/?prestador_id=${prestador_id}`);
                
                if (responseVinculos.data && responseVinculos.data.results && responseVinculos.data.results.length > 0) {
                    // Pega o ID do primeiro programa encontrado
                    programa_id = responseVinculos.data.results[0].programa_id;
                    console.log("Programa encontrado via vínculo do prestador:", programa_id);
                }
            } catch (error) {
                console.error("Erro ao buscar vínculos do prestador:", error);
            }
        }

        if (programa_id) {
            api.get(`/programas/${programa_id}/`)
                .then(response => {
                    const dadosResponse = response.data;
                    this.setState({ 
                        programa_dados: dadosResponse,
                        loadingDados: false 
                    });
                })
                .catch(error => {
                    console.error('Erro ao carregar dados do programa atual:', error);
                    this.setState({ 
                        loadingDados: false,
                        erro: "Erro ao carregar dados do programa."
                    });
                });
        } else {
             console.warn("Nenhum programa identificado para este usuário.");
             this.setState({ 
                 loadingDados: false,
                 erro: "Nenhum programa vinculado encontrado."
             });
        }
    };

    handlePdfLoaded = (key) => {
        this.setState((prev) => ({
            loadingPdf: { ...prev.loadingPdf, [key]: false }
        }));
    };

    renderPdfCard = (title, url, key) => {
        const { loadingPdf } = this.state;

        if (!url) {
            return (
                <Card className="cardDestaque mb-4">
                    <Card.Header>
                        <div>{title}</div>
                    </Card.Header>
                    <Card.Body>
                        <Alert variant="warning" className="m-0">
                            <FaExclamationTriangle className="me-2" />
                            Este documento não foi cadastrado para este programa.
                        </Alert>
                    </Card.Body>
                </Card>
            );
        }

        return (
            <Card className="cardDestaque mb-4">
                <Card.Header className="d-flex justify-content-between align-items-center">
                    <div className="fw-bold">{title}</div>
                    <div>
                        <Button 
                            size="sm" 
                            variant="outline-primary" 
                            href={url} 
                            target="_blank" 
                            rel="noopener noreferrer"
                            title="Baixar ou Visualizar em nova aba"
                        >
                            <FaDownload className="me-1"/> Baixar / Visualizar
                        </Button>
                    </div>
                </Card.Header>
                <Card.Body style={{ padding: 0 }}>
                    {loadingPdf[key] && (
                        <div style={{ padding: 20, textAlign: "center" }}>
                            <Spinner animation="border" variant="primary" size="sm" />
                            <p className="mt-2 text-muted">Carregando documento...</p>
                        </div>
                    )}

                    <div style={{ width: "100%", height: "75vh", borderTop: "1px solid #eee" }}>
                        <iframe 
                            title={title} 
                            src={url} 
                            style={{ width: "100%", height: "100%", border: "none" }} 
                            onLoad={() => this.handlePdfLoaded(key)}
                        />
                    </div>
                </Card.Body>
                <Card.Footer className="text-muted text-end">
                   <small>
                       {this.state.prestador_dados.data_aceite_termo ? (
                           <>Aceito em: <strong>{formataDataHoraExibicao(this.state.prestador_dados.data_aceite_termo)}</strong></>
                       ) : (
                           <>Documento disponível para consulta</>
                       )}
                   </small>
                </Card.Footer>
            </Card>
        );
    };

    render() {
        const { programa_dados, loadingDados, erro } = this.state;

        if (loadingDados) {
            return (
                <div className="text-center mt-5">
                    <Spinner animation="border" role="status">
                        <span className="visually-hidden">Carregando...</span>
                    </Spinner>
                    <p className="mt-2">Carregando termos e políticas...</p>
                </div>
            );
        }

        if (erro) {
             return (
                <div className="mt-4">
                    <Alert variant="danger">
                        <FaExclamationTriangle className="me-2" />
                        {erro}
                    </Alert>
                </div>
            );
        }

        const tabsValidas = [];

        if (programa_dados.termos_programa_medicos) {
            tabsValidas.push("dadosTermoMedico");
        }
        if (programa_dados.regulamento_programa) {
            tabsValidas.push("politicaRegulamento");
        }
        if (programa_dados.aviso_privacidade) {
            tabsValidas.push("politicaPrivacidade");
        }
        if (programa_dados.politica_cookies) {
            tabsValidas.push("politicaCookies");
        }

        const defaultTab = tabsValidas[0] || null;

        return (
            <div>
                <Row className="align-items-center mb-3">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">{this.state.titulo_pagina}</h4>
                    </Col>
                </Row>

                <Tabs defaultActiveKey={defaultTab} id="tabs-termo" className="aditus-tabs mb-3">
                    {programa_dados.termos_programa_medicos && (
                    <Tab eventKey="dadosTermoMedico" title="Termos do Programa">
                        <div className="mt-3">
                            {/* Carrega: termos_programa_medicos */}
                            {this.renderPdfCard("Termos do Programa (Médicos)", programa_dados.termos_programa_medicos, "termo")}
                        </div>
                    </Tab>
                    )}
                    {programa_dados.regulamento_programa && (
                    <Tab eventKey="politicaRegulamento" title="Regulamento do Programa">
                        <div className="mt-3">
                            {/* Carrega: regulamento_programa */}
                            {this.renderPdfCard("Regulamento do Programa", programa_dados.regulamento_programa, "regulamento")}
                        </div>
                    </Tab>
                    )}
                    {programa_dados.aviso_privacidade && (
                    <Tab eventKey="politicaPrivacidade" title="Aviso de Privacidade">
                        <div className="mt-3">
                            {/* Carrega: aviso_privacidade */}
                            {this.renderPdfCard("Aviso de Privacidade", programa_dados.aviso_privacidade, "privacidade")}
                        </div>
                    </Tab>
                    )}
                    {programa_dados.politica_cookies && (
                    <Tab eventKey="politicaCookies" title="Políticas de Cookies">
                        <div className="mt-3">
                            {/* Carrega: politica_cookies */}
                            {this.renderPdfCard("Políticas de Cookies", programa_dados.politica_cookies, "cookies")}
                        </div>
                    </Tab>
                    )}
                </Tabs>
            </div>
        )
    }
}

export default withRouter(TermosMedico);
